import React, { FC, useEffect, useState, useMemo } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { IonContent, IonPage } from '@ionic/react'
import { storeDisplayMobx } from '@mobx/app'
import { storeMobx } from 'restaurant'
import Header from './components/Header'
import { format } from '@dt/fe-utils'
import { modalLayer, useHistoryNew, getPlatform } from '@utils'
import StoreDetailModal from './components/StoreDetailModal'
import './index.scss'

const { isAliPayMiniProgram, isWeixinMiniProgram } = getPlatform()

// interface
interface IProps extends IPage, RouteComponentProps {
  mapType?: string;
  locationOBJ: {
    latitude: string;
    longitude: string;
  };
}

/** 选择门店页 */
const StoreDisplay: FC<IProps> = (props) => {
  const history = useHistoryNew()
  const { storeCityList, nearStore } = storeDisplayMobx

  useEffect(() => {
    storeDisplayMobx.setStoreList(storeMobx.viewStoreList)
  }, [storeMobx.viewStoreList])

  const getPicUrl = (store) => {
    return format.toPic(store?.storeExtInfo?.storePic)
  }

  const handleBack = () => {
    if (isWeixinMiniProgram || isAliPayMiniProgram) { // 小程序内
      history.replace('/home')
    } else if (history.getPrevState()) {
      history.goBack()
    } else {
      history.replace('/home')
    }
  }

  const handleStore = () => {
    modalLayer(StoreDetailModal,
      { data: nearStore, },
      'StoreDetailModal')
      .then((type: any) => {
        if (type === 'menu') {
          storeMobx.initInfo(nearStore)
          history.replace('/menu')
        }
      })
  }
  const handleGoCity = (cityName) => {
    history.push(`/storeDisplay/list/${cityName}`)
  }

  return (
    <IonPage className='store-list-page'>
      <Header onBack={handleBack} title={i18n.t('store.storeDisplayTitle')} />
      <IonContent>
        <div className='near-wrapper' onClick={handleStore}>
          <div className='img-wrap'>
            {getPicUrl(nearStore).url ? <img className='store-img' src={getPicUrl(nearStore).url} /> : <div className='empty-img store-img'></div>}
          </div>
          <div className='name-wrap'>
            <span className='name'>{nearStore?.storeName}</span>
            <span className='distance'>{nearStore?.distanceWithUnit}</span>
          </div>
        </div>
        <div className='more-city-wrapper'>
          <div className='city-title'>{i18n.t('store.storeDisplayMore')}</div>
          <div className='city-wrapper'>
            {
              storeCityList.map((city, index) => {
                const pic = getPicUrl(city.list[0])
                const count = city.list.length
                const cityName = city.key
                return (
                  <div className='city-item-wrapper' key={index} onClick={() => handleGoCity(cityName)}>
                    <div className='city-left-wrap'>
                      <div className='bg-txt'>CITY</div>
                      <div className='city'>{cityName}</div>
                      <div className='count-wrap'>
                        <span className='city-line'>/</span>
                        <span className='count'>{count}</span>
                      </div>
                    </div>
                    <div className='city-right-wrap'>
                      <div className='img-wrap'>
                        {pic.url ? <img className='store-img' src={pic.url} /> : <div className='empty-img store-img'></div>}
                      </div>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(StoreDisplay)
